import React from "react";
import {Typography, Box, Grid, List, ListItem, ListItemIcon, Container} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const Cerkezkoy = () => {
    const services = [
        "Şirket Kuruluş Hizmetleri",
        "Muhasebe Ve Mali Müşavirlik Hizmetleri",
        "Mali Danışmanlık Hizmetleri",
        "SGK danışmanlığı hizmetleri",
        "Şirket bünyesinde, muhasebe, müşavirlik, danışmanlık, mali danışmanlık hizmetleri",
        "Bordrolama Ve Personel Hizmetleri",
        "Şirket kuruluş danışmanlık hizmetleri",
        "Şahıs Firmaları ile diğer tüzel firmaların nevi değişiklik hizmetleri",
        "Ticaret odası ile Esnaflar odası için gerekli olan mesleki oda kayıt hizmetleri",
        "İhracat-ithalat danışmanlık hizmetleri",
    ];

    const faydalar = [
        "İşletme ve kuruluşun gerçekleştirdiğifaaliyetlerin anlaşılması temel olan bilgilerin toparlanması, ilgililere aktarılmasını sağlar.",
        "İşletmenin esasında sahip olduğu kıymetlerin tespit edilmesini sağlar.",
        "İşletmede gerçekleştirilen dönem içi faaliyetler ile dönemin sonunda ulaşılan bu sonuçların anlaşılmasını kolaylaştırır.",
        "İşletme ve iş yapan üçüncü şahısların hem ekonomik hem de sosyal açıdan durumların bilinmesini sağlar.",
        "Üçüncü şahıslar ile işletme arasında gerçekleşebilecek olan  hukuki anlaşmazlıklarda ise devir teşkil eder.",
        "İşletme içerisinde çalışan personel ve de görevlilerin suiistimal edilmesine karşı işletmenin olan varlığını korur.",
        "İşletme sahibinin vergi konularıyla alakalı olan durumu hesap üzerinden inceleyip kontrol kontrolünü sağlar."
    ];

    return (
        <Container maxWidth="lg" sx={{my: 5}}>
            <Grid container spacing={4} alignItems="center">
                {/* Yazı Kısmı */}
                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body1" sx={{mt: 2, color: "#333"}}>
                            <strong>Biz SMMM olarak</strong>, mali müşavir
                            hizmetini <strong>Çerkezköy</strong> bölgesinde
                            en iyi hizmeti sunarak müşterilerinin memnuniyetini en üst noktada
                            tutmak için çalışmalarına hız kesmeden devam etmektedir.
                        </Typography>
                        <Typography variant="body1" sx={{mt: 2, color: "#333"}}>
                            Müşterilerin mali mevzuat konusundaki sorularını yanıtlamaya yönelik
                            kapsamlı çalışmalar gerçekleştirerek danışmanlık hizmeti verir.
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" sx={{mt: 2, color: "red"}}>
                            Bizi Hemen Arayın: 0552 167 36 34
                        </Typography>
                        <Typography variant="body1" sx={{mt: 2, color: "#333"}}>
                            Biz SMMMM olarak müşterilerinin istek ve beklentilerinin üzerinde
                            profesyonel bir hizmet almak için devamlı yenileme eğitim ve de geliştirme çabası
                            içerisindedir. <strong>Çerkezköy</strong> içerisinde hızlı bir diyalog anlayışına sahip olup mali
                            mevzuattaki ve faaliyet konularındaki gelişmeleri yakından takip ederek günü gününe
                            müşterilerine ulaştırarak önlem alabilmelerini, faaliyetlerini yönlendirebilmelerini sağlar.
                        </Typography>
                    </Box>
                </Grid>

                {/* Resim Kısmı */}
                <Grid item xs={12} md={6}>
                    <Box component="img"
                         src="/mm.jpg"
                         alt="Çerkezköy Muhasebe"
                         height={350}
                         sx={{width: "350px", borderRadius: 2, boxShadow: 3}}
                    />
                </Grid>
            </Grid>

            <Box sx={{mt: 5}}/>

            {/* Hizmetler */}
            <Grid container spacing={4} alignItems="center">
                {/* Yazı Kısmı */}
                <Grid item xs={12} md={12}>
                    <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
                        Hangi hizmetleri veriyoruz?
                    </Typography>
                    <List>
                        {services.map((service, index) => (
                            <ListItem key={index}
                                      sx={{display: "flex", alignItems: "center", fontSize: "16px", color: "#333"}}>
                                <ListItemIcon sx={{minWidth: "30px", color: "#ff5722"}}>
                                    <CheckIcon color="success"/>
                                </ListItemIcon>
                                {service}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>

            {/* Faydalar */}
            <Grid container spacing={4} alignItems="center">
                {/* Yazı Kısmı */}
                <Grid item xs={12} md={12}>
                    <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
                        Serbest muhasebeci kullanmanın faydaları nelerdir?
                    </Typography>
                    <List>
                        {faydalar.map((service, index) => (
                            <ListItem key={index}
                                      sx={{display: "flex", alignItems: "center", fontSize: "16px", color: "#333"}}>
                                <ListItemIcon sx={{minWidth: "30px", color: "#ff5722"}}>
                                    <CheckIcon color="success"/>
                                </ListItemIcon>
                                {service}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>

            {/* Önem */}
            <Grid container spacing={4} alignItems="center">
                {/* Yazı Kısmı */}
                <Grid item xs={12} md={12}>
                    <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
                        Bir işletme için hangi SMMM ile çalışacağı neden önemli?
                    </Typography>
                    <Typography variant="body1" sx={{mt: 2, color: "#333"}}>
                        İşletme hangi sektörde kurulmuş olursa olsun, kazancın ne kadar olduğu, hesapların düzgün
                        tutulup tutulmadığı, belgelerde eksikliklerin olmaması, yaşanan aksaklıklar ve yanlışlıklar
                        cezalarla karşılık bulmakta ve işletme ticari hayatına devam edememektedir.
                    </Typography>

                    <Typography variant="body1" sx={{mt: 2, color: "#333"}}>
                        İşletmenin devamlılığı ve güvenliği açısından işinde uzman olan <strong>Serbest Muhasebeci Mali Müşavir</strong> ile çalışmak çok önemli bir gerekliliktir.
                    </Typography>

                    <Typography variant="body1" sx={{mt: 2, color: "#333"}}>
                        <strong>Gülden Çetinkaya Kopan</strong>
                    </Typography>
                    <Typography variant="body1" sx={{mt: 0, color: "#333"}}>
                        Bizi Hemen Arayın:<strong>0552 167 36 34</strong>
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Cerkezkoy;
